import { FieldApi } from '@tanstack/react-form';
import { match } from 'ts-pattern';

export function getErrors(field: FieldApi<any, any, any, any>) {
  return match(fieldHasError(field))
    .with(true, () => joinErrors(field))
    .with(false, () => undefined)
    .otherwise(() => undefined);
}

export function getNestedFieldError<T>(
  field: FieldApi<T, any, any, any>,
  path: keyof T | string,
): string | undefined {
  if (!fieldHasError(field)) return undefined;

  const matchingError = field?.state?.meta?.errors?.find((error: any) => {
    if (!Array.isArray(error?.path)) {
      return false;
    }

    return error?.path?.some((errorPath: any) => errorPath?.key === path);
  });

  return matchingError?.message;
}

function fieldHasError(field: FieldApi<any, any, any, any>) {
  return field?.state?.meta?.isTouched && !!field?.state?.meta?.errors?.length;
}

function joinErrors(field: FieldApi<any, any, any, any>) {
  return field?.state?.meta?.errors
    ?.map((error: any) => error?.message)
    .join(', ');
}
